import React from "react";
import Chart from "react-apexcharts";

export default function PlannedSpentBudgetChart({data,selectedCountry}) {
  // const data = [
  //   {
  //     name: "Plan Budget",
  //     quantity: 2700
  //   },
  //   {
  //     name: "Spent Budget",
  //     quantity: 2300
  //   },
  // ];

  const totalBudget = data?.reduce((sum, item) => sum + item.budget, 0);
  const names = data?.map(n => n?.name);
  const quantities = data?.map(
    (item) => parseFloat(((item.budget / totalBudget) * 100).toFixed(1)) // Round to 2 decimal places
  );

  // const names = data.map(n => n.name);
  // const quantities = data.map(n => n.budget);

  const options = {
    labels: names,
    legend: {
      show: false,
    },
    colors: ["#0E7094", "#6DD1E3"],
    chart: {
      type: 'pie'
    },
    dataLabels: {
      enabled: true,
      formatter: (val, opts) => {
        const index = opts.seriesIndex;
        const value = quantities[index];
        return `${value.toLocaleString()}%`;
      },
      style: {
        fontSize: '14px',
        colors: ['#000'],
        fontWeight: 'normal'
      },
      dropShadow: {
        enabled: false
      },
    },
    tooltip: {
      y: {
        formatter: (val) => {
          return `${val.toLocaleString()}%`;
        }
      }
    },
    plotOptions: {
      pie: {
        dataLabels: {
            offset: -35,
          },
      },
    },
    responsive: [
      {
        breakpoint: 1660,
        options: {
          chart: {
            width: "300",
          },
        },
      },
      {
        breakpoint: 1200,
        options: {
          chart: {
            width: "250",
          },
        },
      },
      {
        breakpoint: 420,
        options: {
          dataLabels: {
            style: {
              fontSize: '10px',
            },
          },
        },
      },
    ]
  };

  const series = quantities;

  return (
    <Chart
      options={options}
      series={series}
      type="pie"
      width="380"
    />
  );
}
